const FirstStepsRoutes = [
  {
    path: '/fs-dashboard',
    name: 'fs-dashboard',
    component: () => import('../dashboard/FSDashboard.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-about-me',
    name: 'fs-about-me',
    component: () => import('../about-me/FSAboutMe.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-people',
    name: 'fs-my-people',
    component: () => import('../my-people/FSMyPeople.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-health',
    name: 'fs-my-health',
    component: () => import('../my-health/FSMyHealth.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-care-wishes',
    name: 'fs-my-care-wishes',
    component: () => import('../my-care-wishes/FSMyCareWishes.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-legal-pack',
    name: 'fs-my-legal-pack',
    component: () => import('../my-legal-pack/FSMyLegalPack.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-money',
    name: 'fs-my-money',
    component: () => import('../my-money/FSMyMoney.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-documents',
    name: 'fs-my-documents',
    component: () => import('../my-documents/FSMyDocuments.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-digital-life',
    name: 'fs-my-digital-life',
    component: () => import('../my-digital-life/FSMyDigitalLife.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-funeral-wishes',
    name: 'fs-my-funeral-wishes',
    component: () => import('../my-funeral-wishes/FSMyFuneralWishes.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-will-prep',
    name: 'fs-my-will-prep',
    component: () => import('../my-will-prep/FSMyWillPrep.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-epa-prep',
    name: 'fs-my-epa-prep',
    component: () => import('../my-epa-prep/FSMyEPAPrep.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-my-ahd-prep',
    name: 'fs-my-ahd-prep',
    component: () => import('../my-ahd-prep/FSMyAHDPrep.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-share/view/:token',
    name: 'fs-share-view',
    component: () => import('../share/FSShareView.vue'),
    meta: { layout: 'blank-layout' },
  },
  {
    path: '/fs-share',
    name: 'fs-share',
    component: () => import('../share/FSShare.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-guides',
    name: 'fs-guides',
    component: () => import('../guides/FSGuides.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-glossary',
    name: 'fs-glossary',
    component: () => import('../glossary/FSGlossary.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  {
    path: '/fs-account',
    name: 'fs-account',
    component: () => import('../account/FSAccount.vue'),
    meta: { layout: 'first-steps-layout' },
  },
  // Public auth pages — no auth required, use blank layout
  {
    path: '/first-steps/signup',
    name: 'fs-signup',
    component: () => import('../auth/FSSignup.vue'),
    meta: { layout: 'first-steps-auth-layout' },
  },
  {
    path: '/first-steps/login',
    name: 'fs-login',
    component: () => import('../auth/FSLogin.vue'),
    meta: { layout: 'first-steps-auth-layout' },
  },
  {
    path: '/first-steps/verify-email',
    name: 'fs-verify-email',
    component: () => import('../auth/FSVerifyEmail.vue'),
    meta: { layout: 'first-steps-auth-layout' },
  },
  {
    path: '/fs-checkout',
    name: 'fs-checkout',
    component: () => import('../auth/FSCheckout.vue'),
    meta: { layout: 'first-steps-auth-layout' },
  },
  {
    path: '/fs-checkout/success',
    name: 'fs-checkout-success',
    component: () => import('../auth/FSCheckoutSuccess.vue'),
    meta: { layout: 'first-steps-auth-layout' },
  },
  {
    path: '/fs-paywall',
    name: 'fs-paywall',
    component: () => import('../auth/FSPaywall.vue'),
    meta: { layout: 'first-steps-auth-layout' },
  },
]

export default FirstStepsRoutes
